import React from "react";
import DocumentsFile from "v4/components/form/ShowField/components/DocumentFile/DocumentFile";
import 'v4/components/form/ShowField/components/DocumentsList/DocumentsList.scss';

export default function DocumentsList({overrideData, name, whenDeleteFile, filesFromServer = []}) {

    const handleRemoveFiles = (file) => {
        overrideData(data => {
            // Now we remove the file from the values of [name] to remove it from the list
            const quoteCustomerFilesGroup = Object.values(data.results ?? {}).find(({properties}) => properties.some(({name: fieldName}) => fieldName === name));
            if (quoteCustomerFilesGroup) {
                const customerFiles = quoteCustomerFilesGroup.properties.find(({name: fieldName}) => fieldName === name);
                if (customerFiles) {
                    customerFiles.value = customerFiles.value.filter(({id}) => id !== file.id);
                }
            }

            return data;
        })
        whenDeleteFile && whenDeleteFile();
    }

    return (
        <div className={`documents-list multiple'`}>
            {filesFromServer?.filter(({quotePdf}) => !quotePdf).map((file, index) => (
                <DocumentsFile key={file.fileName ?? index} file={file} handleRemoveFiles={handleRemoveFiles}/>
            ))}
        </div>
    )
}
